import {mainQuery} from '@github-ui/react-core/future/main-query'
import {dashboardSurfaceAppBuilder} from '../config/app-builder'
import {PULLS_PATH} from '../constants/routes'
import type {PullsDashboardLayoutPayload} from '../types/routes-types'

export const pullsDashboardSurfaceLayoutRoute = dashboardSurfaceAppBuilder.createQueryRouteConfig(
  'pullsDashboardSurfaceLayoutRoute',
  {
    path: PULLS_PATH,
    queries: [
      mainQuery<PullsDashboardLayoutPayload>({
        queryDeps: ({pathname}) => ({pathname: `${pathname}/_layout`}),
        staleTimeForNavigation: 360000, // 6 minutes in milliseconds
      }),
    ],
  },
)
